export const SmsTypes = {

    CODE_TO_VERIFICATION:"کد ورود",
    CORPORATE_LOW_BUDGET:"کمبود شارژ",
    JOINED_TO_PLACE:"پرسنل مجموعه",
    JOINED_TO_CORPORATE:"پرسنل سازمان",
    JOIN_PLACE_REQUEST:"درخواست عضویت مجموعه",
    USER_CHARGE:"شارژ کاربر",
    CORPORATE_CHARGE:"شارژ سازمان",
    USER_BUY_SUBSCRIBE:"خرید عضویت",
    SUPPORT_ANSWERED:"پشتیبانی",
    null:"نامشخص"
}
